import { en } from "./en.js";
import { nl } from "./nl.js";

/** @type {Record<string, import("../catalogTypes.js").MessageCatalog>} */
export const catalogs = {
  nl,
  en,
};

export { en, nl };
